import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Users, FileText, Truck, Target, UserCheck,
  Calendar, BarChart2, PieChart, Settings, ChevronLeft, ChevronRight, Car
} from 'lucide-react';

const navItems = [
  { path: '/', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/prospecting', label: 'Prospecting', icon: Users },
  { path: '/spk', label: 'SPK', icon: FileText },
  { path: '/delivery', label: 'Delivery', icon: Truck },
  { path: '/lead-management', label: 'Lead Management', icon: Target },
  { path: '/team', label: 'Tim Sales', icon: UserCheck },
  { path: '/calendar', label: 'Kalender', icon: Calendar },
  { path: '/performance', label: 'Performance', icon: BarChart2 },
  { path: '/reports', label: 'Laporan', icon: PieChart },
  { path: '/settings', label: 'Pengaturan', icon: Settings },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <aside className={`${collapsed ? 'w-16' : 'w-60'} bg-white border-r border-gray-100 flex flex-col transition-all duration-300 relative z-10 shadow-sm`}>
      {/* Logo */}
      <div className="h-16 flex items-center px-4 border-b border-gray-100 gap-3 overflow-hidden">
        <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <Car size={16} className="text-white" />
        </div>
        {!collapsed && (
          <div className="overflow-hidden">
            <p className="text-sm font-bold text-red-600 leading-tight">Honda Sales</p>
            <p className="text-xs text-gray-400 leading-tight">Management</p>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4 px-2 space-y-1">
        {navItems.map(({ path, label, icon: Icon }) => {
          const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
          return (
            <NavLink
              key={path}
              to={path}
              title={collapsed ? label : ''}
              className={`sidebar-link ${isActive ? 'active' : ''} ${collapsed ? 'justify-center' : ''}`}
            >
              <Icon size={18} className="flex-shrink-0" />
              {!collapsed && <span>{label}</span>}
            </NavLink>
          );
        })}
      </nav>

      {/* Collapse toggle */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-3 top-20 w-6 h-6 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-sm hover:bg-gray-50 transition-colors"
      >
        {collapsed ? <ChevronRight size={12} /> : <ChevronLeft size={12} />}
      </button>

      {/* User info */}
      <div className="p-3 border-t border-gray-100">
        <div className={`flex items-center gap-3 ${collapsed ? 'justify-center' : ''}`}>
          <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-red-600 text-xs font-bold">SM</span>
          </div>
          {!collapsed && (
            <div className="overflow-hidden">
              <p className="text-xs font-semibold text-gray-700 truncate">Sales Manager</p>
              <p className="text-xs text-gray-400 truncate">Honda Dealer</p>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}
